import { useMemo } from 'react';

/**
 * useTableSearch
 * @param {Array} data - The table data array
 * @param {Array} columnNames - The column names to search in
 * @param {string} search - The search string
 * @param {Array} [sortedData] - Optionally pass sorted data
 * @param {Object} [sortConfig] - Optionally pass sort config
 * @returns {Array} filteredData
 */
export function useTableSearch({ data, columnNames, search, sortedData, sortConfig }) {
  return useMemo(() => {
    const sourceData = (sortConfig && sortConfig.key && sortConfig.direction) ? sortedData : data;
    if (search.length < 2) return sourceData;
    return sourceData.filter(row =>
      columnNames.some(col =>
        String(row[col] ?? '').toLowerCase().includes(search.toLowerCase())
      )
    );
  }, [data, columnNames, search, sortedData, sortConfig]);
}
